import React, { useState } from 'react';
import { Card, TabbedComponent } from '@dopomogai/ui';
import { Info, MessageSquare, Braces, Server } from 'lucide-react';
import type { InitTestChatResponse } from '@dopomogai/types';
import { SessionInfoPanel } from './SessionInfoPanel';
import { LogPanel } from './LogPanel';
import { OverlaysPanel } from './OverlaysPanel'; // <-- NEW IMPORT
import { HeadersPanel } from './HeadersPanel';   // <-- NEW IMPORT

interface LiveChatDebugPanelProps {
  sessionConfig: InitTestChatResponse | null;
  sseLogs: { timestamp: number; data: any }[];
  lastSentOverlays: object | null;      // <-- NEW PROP
  lastReceivedHeaders: object | null;   // <-- NEW PROP
}

export const LiveChatDebugPanel: React.FC<LiveChatDebugPanelProps> = ({ 
  sessionConfig, 
  sseLogs,
  lastSentOverlays,
  lastReceivedHeaders,
}) => {
  const [activeTab, setActiveTab] = useState('sessionInfo');

  const debugTabs = [
    { 
      id: 'sessionInfo', 
      label: 'Session', 
      icon: <Info size={16} />, 
      content: <SessionInfoPanel config={sessionConfig} /> 
    },
    { // --- NEW TAB FOR OVERLAYS ---
      id: 'overlays', 
      label: 'Overlays', 
      icon: <Braces size={16} />, 
      content: <OverlaysPanel overlays={lastSentOverlays} />
    },
    { // --- NEW TAB FOR HEADERS ---
      id: 'headers',
      label: 'Headers',
      icon: <Server size={16} />,
      content: <HeadersPanel headers={lastReceivedHeaders} />
    },
    { 
      id: 'sseLog', 
      label: 'SSE Log', 
      icon: <MessageSquare size={16} />, 
      content: <LogPanel logs={sseLogs} /> 
    },
  ];

  return (
    <Card noPadding className="h-full flex flex-col">
      <TabbedComponent 
        tabs={debugTabs} 
        activeTabId={activeTab} 
        onTabChange={setActiveTab} 
        containerClassName="flex-1 flex flex-col min-h-0"
        contentClassName="flex-1 min-h-0"
      />
    </Card>
  );
};